// GENERATED FILE - DO NOT MODIFY
import { DataModificationLogFileModel } from "api/models/company/data-modification-log-file-model";
import { PagingInfo } from "api/paging-info";
import BaseProxy from "api/proxies/base-proxy";
import ModelDateTransformer from "api/util/model-date-transformer";
import { autoinject } from "aurelia-framework";
import { ApiHelper } from "helpers/api-helper";
import { HttpClientFactory } from "http-client/http-client-factory";
import { HttpClientRequestConfig } from "http-client/http-client-request-config";

@autoinject()
export class ServiceCallQuotationDataModificationsProxy extends BaseProxy {
    constructor(modelDateTransformer: ModelDateTransformer, httpClientFactory: HttpClientFactory, apiHelper: ApiHelper) {
        super(modelDateTransformer, httpClientFactory, apiHelper);
    }

    public async GetHeaderDataModificationsLogFile(quotationId: number, filter?: string, pagingInfo?: PagingInfo, requestConfig?: HttpClientRequestConfig): Promise<DataModificationLogFileModel[] | null> {
        const uri = this.buildUri(
            "/service-call-quotations/{quotationId}/header/data-modification-log-file",
            { quotationId: (quotationId === null || quotationId === undefined) ? undefined : quotationId.toString() },
            { filter: filter ? filter : undefined, page: (pagingInfo && pagingInfo.page ? pagingInfo.page.toString() : undefined), pagesize: (pagingInfo && pagingInfo.pageSize ? pagingInfo.pageSize.toString() : undefined) }
        );

        const data: DataModificationLogFileModel[] | null = await this.get<DataModificationLogFileModel[] | null>(uri, requestConfig);
        this.transformModels(data, "Company.DataModificationLogFileModel");
        return data;
    }

    public async GetDetailsDataModificationsLogFile(quotationId: number, filter?: string, pagingInfo?: PagingInfo, requestConfig?: HttpClientRequestConfig): Promise<DataModificationLogFileModel[] | null> {
        const uri = this.buildUri(
            "/service-call-quotations/{quotationId}/details/data-modification-log-file",
            { quotationId: (quotationId === null || quotationId === undefined) ? undefined : quotationId.toString() },
            { filter: filter ? filter : undefined, page: (pagingInfo && pagingInfo.page ? pagingInfo.page.toString() : undefined), pagesize: (pagingInfo && pagingInfo.pageSize ? pagingInfo.pageSize.toString() : undefined) }
        );

        const data: DataModificationLogFileModel[] | null = await this.get<DataModificationLogFileModel[] | null>(uri, requestConfig);
        this.transformModels(data, "Company.DataModificationLogFileModel");
        return data;
    }
}
